import React, { useState, useContext } from 'react';
import GithubContext from '../../context/github/githubContext';
import AlertContext from '../../context/alert/alertContext';

const Search = () => {
  const githubContext = useContext(GithubContext);
  const alertContext = useContext(AlertContext);

  const [text, setText] = useState('');

  const onSubmit = e => {
    e.preventDefault();
    if (text === '') {
      alertContext.setAlert('Please enter something', 'light');
    } else {
      githubContext.searchUsers(text);
      setText('');
    }
  };

  const onChange = e => {
    setText(e.target.value);
  };

  return (
    <div className='all-center'>
      <div className='col-sm-12'>
        <form onSubmit={onSubmit} className='my-search'>
          <div className='input-group'>
            <input
              type='text'
              name='text'
              className='form-control'
              aria-label="Recipient's username"
              aria-describedby='basic-addon2'
              placeholder='Search Users ...'
              value={text}
              onChange={onChange}
            />
            <div className='input-group-append'>
              <button className='btn btn-search btn-block' type='submit'>
                Search <i className='fas fa-search' style={iconStyle}></i>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div id='team'>
        <div className='container my-3 py-5 all-center'>
          <div className='row mb-5'>
            <div className='col'>
              <h1 style={headerStyle}>Users</h1>
              <p>Can you find users here they are register in Github</p>
              {githubContext.users.length > 0 && (
                <button
                  className='btn btn-dark btn-block'
                  style={btnClear}
                  onClick={githubContext.clearUsers}
                >
                  Clear <i className='fas fa-chalkboard' style={iconStyle}></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const iconStyle = {
  marginLeft: '5px',
  fontSize: '16px'
};

const btnClear = {
  marginTop: '15px'
};

const headerStyle = {
  color: '#cd5c5c'
};

export default Search;
